import { createSlice } from "@reduxjs/toolkit";

const initialprogramReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  programReportForEdit: undefined,
  lastError: null,
  // ! PROGRAM, DONOR, DONATION COUNT
  donorCount: 0,
  donationCount: 0,
  programCount: 0,
  // ? LIBRARY FILES
  programReportFiles: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const superAdminProgramReportSlice = createSlice({
  name: "programReport",
  initialState: initialprogramReportState,
  reducers: {
    catchError: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      // state.error = `${action.type}: ${action.payload.error}`;
      // if (action.payload.callType === callTypes.list) {
      //   state.listLoading = false;
      // } else {
      //   state.actionsLoading = false;
      // }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getprogramReportById
    programReportFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.programReportForEdit = action.payload.programReportForEdit;
      state.donorCount = action.payload.donorCount;
      state.donationCount = action.payload.donationCount;
      state.programCount = action.payload.programCount;
    },
    // findprogramReport
    programReportsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    programReportReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },
    programReportFiles: (state, action) => {
      state.programReportFiles = action.payload.items;
      state.totalCount = action.payload.total_items;
      state.listLoading = false;
      state.actionsLoading = false;
    },
    programReportFilesFetched: (state, action) => {
      state.programReportFiles = action.payload.items;
      state.listLoading = false;
      state.actionsLoading = false;
    }
  }
});
